import { useAccessCode } from '../use-access-code';
import { usePublicBrandingPartnerConfig } from '../use-public-branding-partner-config';

export function usePartnerFromAccessCode() {
    const { accessCode, isAccessCodeFromQuery, isReady } = useAccessCode();
    const {
        brandingPartnerConfig,
        isFetched: isBrandingPartnerConfigFetched,
        enabled,
    } = usePublicBrandingPartnerConfig(isAccessCodeFromQuery ? accessCode : '');

    const isFetched = isBrandingPartnerConfigFetched && isReady;

    return { isFetched, brandingPartnerConfig, enabled };
}
